import Switcher from '../control/Switcher'

const CONTENT_TYPES = ['articles', 'questions', 'discussions', 'answers']

const Visibility = (props) => {
  let { visibility } = props
  return (
    <div className={'row'}>
      <label>Visibility</label>
      <p>Specify in which content types you want to show this element</p>
      {
        CONTENT_TYPES.map(c => {
          let contentType = c
          let v = visibility[c]
          return (
            <div className={'col-md-6 content-helpfulness_visibility-checks'}>
              <Switcher on={v} onChange={() => props.onChange({
                [contentType]: !v
              })} />
              <label className={'switch-label'}>{contentType === 'discussions' ? 'conversations' : contentType}</label>
            </div>
          )
        })
      }
    </div>
  )
}

export default Visibility
